<div class="hide-it">
  <input
    type="hidden"
    id="appLoadFlag"
    data-testid="appLoadFlag"
    [value]="true"
  >

  <input
    type="hidden"
    id="appAuthFlag"
    data-testid="appAuthFlag"
    [value]="(auth.authStatus$|async)?.isLogged ? 'true' : 'false'"
  >

</div>
